// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__d7c8G","consentsList":"PatientConsents_consentsList__rGHQw","consentsListEmpty":"PatientConsents_consentsListEmpty__1PFIk"};